import DownloadSvg from '@assets/images/svg/download.svg';
import React from 'react';

export interface DownloadIconProps {
    size?: number;
    color?: string;
}

export function DownloadIcon({ size = 24, color = '#333333' }: DownloadIconProps) {
    return (
        <DownloadSvg width={size} height={size} color={color} />
    );
}

export default DownloadIcon;
